import { useEffect } from 'react';

import Questionnaire from './Questionnaire';

const LiabilityExposures = (props) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        props.doGetPolicy();
    }, []);

    return <Questionnaire {...props} />;
};

export default LiabilityExposures;
